var React = require('react');

function Nextstep (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.994 1.157a1.517 1.517 0 0 1 2.199 0L19.5 12 9.193 22.843a1.517 1.517 0 0 1-2.2-2.09L15.314 12l-8.32-8.753a1.517 1.517 0 0 1 0-2.09z","fill":"#fff"}));
}

Nextstep.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Nextstep;

Nextstep.default = Nextstep;
